import React, { Component } from 'react';
import Header from './../../components/user/common/Header';
import PageTitle from './../../components/user/common/PageTitle';
import Footer from './../../components/common/Footer';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import Total from '../../components/user/common/Total';
import { resolveCategoryId, resolveProductId } from '../../utils/resolveCategoryId';
import CartItem from '../../components/user/common/CartItem';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { clearCart } from '../../store/reducers/cart-slice-reducer';
import { updateCart } from "../../store/reducers/cart-slice-reducer";
import emptyCart from './../../assets/images/empty-cart.png';
import { Helmet } from 'react-helmet';

class MyCart extends Component {
    constructor(props) {
        super(props);
        this.authInfo = JSON.parse(localStorage.getItem('authInfo'));
        this.state = {
            data: [],
            couponCode: null,
            couponData: null,
            sellerId: null, // Added sellerId to state
            reqBody: {
                count: {
                    start: 0,
                    limit: 5
                }
            },
        };
        toast.configure();
    }

    async componentDidMount() {
        const authInfo = this.authInfo;
        const cart = this.props.cart;
        
        if (!authInfo) {
            return;
        }

        // Check if an order was recently placed
        const recentOrderFlag = localStorage.getItem('recentOrderPlaced');
        if (recentOrderFlag) {
            //console.log('Recent order detected, skipping cart restoration');
            localStorage.removeItem('recentOrderPlaced');
            // Clear Redux cart to be safe
            this.props.dispatch(clearCart());
            return;
        }

        const { id, token } = authInfo;
        const cartFromRedux = this.props.cart;
        const updateCartData = {
            cartFromRedux: cartFromRedux,
            userId: id
        }

        try {
            const response = await axios.post('user/updateCartData', updateCartData, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${token}`,
                }
            });

            const dbCart = response?.data?.data || [];
        } catch (err) {
            toast.error('Error while updating cart data on login:', err);
        }

        try {
            const response = await axios.get(`user/getCartData/${id}`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${token}`,
                }
            });

            const dbCart = response?.data?.data || [];
            console.log('Cart data fetched from DB:', dbCart);

            // If no cart data or empty cart, just return silently
            if (!Array.isArray(dbCart) || dbCart.length === 0) {
                console.log('No cart data found in the database.');
                return;
            }

            // Filter and process only valid cart items
            const validCartItems = dbCart.filter(cartItem => 
                cartItem && 
                cartItem.products && 
                Array.isArray(cartItem.products) && 
                cartItem.products.length > 0
            );

            if (validCartItems.length === 0) {
                console.log('No valid cart items found.');
                return;
            }

            const enhancedDbCart = validCartItems.map(cartItem => {
                const validProducts = cartItem.products.filter(product => resolveProductId(product));

                if (validProducts.length === 0) {
                    return null;
                }

                return {
                    ...cartItem,
                    products: validProducts.map(product => ({
                        ...product,
                        id: resolveProductId(product),
                        productId: resolveProductId(product),
                        name: product.name || product.productId?.name || product.productId?.title || '',
                        price: product.price || 0,
                        quantity: product.qty || 1,
                        image: product.image || product.productId?.featuredImage || product.productId?.image || '',
                        categoryId: resolveCategoryId(product),
                        category: product.category || product.productId?.category || null,
                        createdBy: product.createdBy || product.sellerId || product.productId?.createdBy || product.productId?.sellerId || null,
                        sellerId: product.sellerId || product.createdBy || product.productId?.createdBy || product.productId?.sellerId || null,
                        color: product.color || '',
                        size: product.size || '',
                        coins: product.coins || 0,
                    }))
                };
            }).filter(cartItem => cartItem !== null);

            if (enhancedDbCart.length === 0) {
                console.log('No valid products after processing.');
                return;
            }

            console.log("ENHANCED DB CART: ", enhancedDbCart);

            // Extract seller ID from dbCart
            this.extractSellerIdFromDbCart(enhancedDbCart);

            const mergedCart = this.mergeCartData(cartFromRedux, enhancedDbCart);
            this.updateCartInRedux(mergedCart);
            this.setState({ data: mergedCart });

        } catch (err) {
            console.error('Error while fetching cart data:', err);
            
            if (err.response && err.response.status !== 200) {
                const message = err.response?.data?.message || 'Failed to load cart data.';
                toast.error(message, { autoClose: 3000 });
            } else if (err.request) {
                toast.error('Network error or server unreachable.', { autoClose: 3000 });
            }
        }
    }

    // Helper method to extract seller ID from dbCart
    extractSellerIdFromDbCart = (dbCart) => {
        try {
            if (dbCart && dbCart.length > 0) {
                const firstCartItem = dbCart[0];
                console.log("FIRST CART ITEM: ", firstCartItem)
                if (firstCartItem.products && firstCartItem.products.length > 0) {
                    const firstProduct = firstCartItem.products[0];
                    console.log("FIRST PRODUCT: ", firstProduct)
                    const sellerId = firstProduct.productId?.createdBy;
                    
                    if (sellerId) {
                        console.log('Seller ID extracted:', sellerId);
                        this.setState({ sellerId: sellerId });
                    } else {
                        console.warn('No createdBy field found in product data');
                        this.setState({ sellerId: null });
                    }
                } else {
                    console.warn('No products found in cart data');
                    this.setState({ sellerId: null });
                }
            } else {
                console.warn('No cart data available');
                this.setState({ sellerId: null });
            }
            //console.log("SELLER ID: ", sellerId)
        } catch (error) {
            console.error('Error extracting seller ID:', error);
            this.setState({ sellerId: null });
        }
    };

    mergeCartData = (reduxCart, dbCart) => {
    // ** ADD: Debug logging to see actual structure **
    console.log("=== DEBUG: DB Cart Structure ===");
    console.log("dbCart:", JSON.stringify(dbCart, null, 2));
    
    if (dbCart.length > 0 && dbCart[0].products && dbCart[0].products.length > 0) {
        console.log("First product structure:", JSON.stringify(dbCart[0].products[0], null, 2));
        console.log("productId structure:", JSON.stringify(dbCart[0].products[0].productId, null, 2));
    }

    const validDbCart = dbCart.filter(dbProduct => {
        if (!Array.isArray(dbProduct?.products) || dbProduct.products.length === 0) {
            console.log("Invalid dbProduct - no products array:", dbProduct);
            return false;
        }

        // ** UPDATE: Check different possible structures **
        const hasValidProduct = dbProduct.products.some(product => {
            console.log("Checking product:", product);
            console.log("product.productId:", product.productId);
            console.log("Available keys in productId:", Object.keys(product.productId || {}));
            
            // Try different possible structures
            return product?.productId?._id || 
                   product?.productId?.id || 
                   product?.productId;
        });

        if (!hasValidProduct) {
            console.error('No valid product in DB cart item:', dbProduct);
        }

        return hasValidProduct;
    });

    const mergedCart = [...reduxCart];
    let sellerIds = new Set();

    validDbCart.forEach(dbProduct => {
        dbProduct.products.forEach(product => {
            // ** UPDATE: Try different ID extraction methods **
            const dbProductId = resolveProductId(product);
                              
            const sellerId = product?.sellerId || product?.createdBy;
            if (sellerId) {
                sellerIds.add(sellerId); 
            }

            if (!dbProductId) {
                console.warn('Skipping product with missing ID:', product);
                return;
            }
                console.log("PRODUCT: ", product)
                const existingProductIndex = mergedCart.findIndex(item => item.id === dbProductId);
                console.log("EXISTING PRODUCT INDEX: ", existingProductIndex)
                if (existingProductIndex !== -1) {
                    mergedCart[existingProductIndex] = {
                        ...mergedCart[existingProductIndex],
                        quantity: product?.qty,
                        discountId: product?.discountId?.id || null,
                        discountPercent: product?.discountId?.discount || 0,
                        color: product?.color,
                        size: product?.size,
                        createdBy: sellerId,
                        sellerId: sellerId,
                        // ** UPDATE: Properly extract category info **
                        categoryId: resolveCategoryId(product),
                        category: product?.category || product?.productId?.category || null
                    };
                } else {
                    mergedCart.push({
                        coins: product.coins,
                        id: dbProductId || 'Unknown ID',
                        image: product?.image || product?.productId?.featuredImage || 'default-image-url.jpg',
                        name: product?.name || product?.productId?.name || 'Unknown Name',
                        price: product?.price || 0,
                        quantity: product?.qty || 1,
                        discountId: product?.discountId?.id || null,
                        discountPercent: product?.discountId?.discount || 0,
                        color: product?.color,
                        size: product?.size,
                        createdBy: sellerId,
                        sellerId: sellerId,
                        // ** UPDATE: Properly extract category info from populated data **
                        categoryId: resolveCategoryId(product),
                        category: product?.category || product?.productId?.category || null
                    });
                }
            });
        });
        this.setState({
            sellerId: Array.from(sellerIds).map(id => String(id)) 
        });

        console.log("Merged cart with sellerId and categoryId:", mergedCart);
        return mergedCart;
    };

    updateCartInRedux = (mergedCart) => {
        // Make sure sellerId is preserved
        const cartWithSellerId = mergedCart.map(item => ({
            ...item,
            sellerId: item.sellerId || item.createdBy,
            createdBy: item.createdBy || item.sellerId
        }));
        
        const { dispatch } = this.props;
        dispatch(updateCart(cartWithSellerId));
    };

    handleApplyCoupon = async () => {
        const { couponCode } = this.state;
        const { token, id } = this.authInfo;
        try {
            const response = await axios.get(`user/coupon/${couponCode}?userId=${id}`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${token}`
                }
            });
            if (response.data.status === true) {
                let data = response.data.data;
                this.setState({ couponData: data });
                toast.success(response.data.message, { autoClose: 3000 });
            }
            if (response.data.status === false) {
                console.log("Error message", response.data.message);
                toast.error(response.data.message, { autoClose: 3000 });
            }
        } catch (err) {
            console.error("Error caught:", err);
            if (err.response) {
                const status = err.response.status;
                const message = err.response.data?.data?.message || "An unexpected error occurred.";
                console.log("Error status:", status, "Message:", message);
                if (status === 404) {
                    toast.error(message, { autoClose: 3000 });
                } else if (status === 400) {
                    toast.error("Invalid request: " + message, { autoClose: 3000 });
                } else {
                    toast.error(message, { autoClose: 3000 });
                }
            } else {
                toast.error("Network error or server unreachable.", { autoClose: 3000 });
            }
        }
    };

    render() {
        const cart = this.props.cart;
        const { sellerId } = this.state; // Destructure sellerId from state
        
        const getTotal = () => {
            let totalQuantity = 0
            let totalPrice = 0
            cart.forEach(items => {
                totalQuantity += items.quantity
                totalPrice += items.price * items.quantity
            })
            return { totalPrice, totalQuantity }
        }

        return (
            <React.Fragment>
                <Helmet><title>{"My Cart - Pay Earth"}</title></Helmet>
                <Header />
                <PageTitle title="My Cart" />
                <section className="inr_wrap">
                    <div className="container">
                        <div className="bg-white rounded-3">
                            <div className='row'>
                                <div className={cart.length === 0 ? "col-md-12" : "col-md-8"}>
                                    <div className="cart my_cart m-2">
                                        {getTotal().totalQuantity === 0 ?
                                            <div align="center">
                                                <img src={emptyCart} alt='...' width="300px" height="300px" />
                                                <h1>Your Cart Is Empty......!</h1>
                                                <div className="ctn_btn"><Link to="/product-listing" className="view_more">Continue shopping</Link></div>
                                                &nbsp;
                                            </div>
                                            :
                                            <div>
                                                <div className="cart_wrap">
                                                    <div className="items_incart">
                                                        <span>{getTotal().totalQuantity} Items in your cart</span>
                                                    </div>
                                                </div>
                                                <div className="cl_head">
                                                    <div className="cart_wrap">
                                                        <div>Product</div>
                                                        <div>Quantity</div>
                                                        <div>Total</div>
                                                        <div className="invisible">Actions</div>
                                                    </div>
                                                </div>
                                                <div className="cart_list cart_wrap">
                                                    <div className="custom-card">
                                                        {cart.map((item) => {
                                                            return (
                                                                <CartItem 
                                                                    key={item.id} 
                                                                    id={item.id} 
                                                                    image={item.image} 
                                                                    title={item.name} 
                                                                    price={item.price} 
                                                                    quantity={item.quantity} 
                                                                    discountId={item.discountId} 
                                                                    discountPercent={item.discountPercent} 
                                                                    coins={item.coins} 
                                                                    vatTax={item.vat} 
                                                                    stock={item.stock}
                                                                />
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    {cart.length === 0 ? "" :
                                        <div className="cart_wrap mb-5">
                                            <div className="items_incart d-flex justify-content-center align-items-center">
                                                <span>have a coupons <Link to="/my-coupons">Click here to have</Link> </span>
                                            </div>
                                            <div className="cart_wrap">
                                                <div className="checkout_cart_wrap">
                                                    <p>IF YOU HAVE A COUPON CODE, PLEASE APPLY IT BELOW </p>
                                                    <div className="input-group d-flex">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter your coupons code"
                                                            aria-label="Example text with button addon"
                                                            value={this.state.couponCode}
                                                            onChange={(e) => this.setState({ couponCode: e.target.value })}
                                                            id="myCoupon"
                                                        />
                                                        <button
                                                            className="btn custom_btn btn_yellow"
                                                            type="button"
                                                            onClick={this.handleApplyCoupon}
                                                        >
                                                            Apply coupon code
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {/* Pass sellerId to Total component */}
                                    {cart.length === 0 ? "" : 
                                        <Total 
                                            couponData={this.state.couponData} 
                                            sellerId={cart[0]?.sellerId}  
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        cart: state.cart.cart
    }
}

export default connect(mapStateToProps)(MyCart);